export default __webpack_public_path__ + "static/media/deserts.3457e289.jpg";